import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import tabgrid from "../../../../../utilities/TabGrid";
import acc from 'accounting'
import LSService from "../../../../../utilities/localStorageService/LSService";
import InfoTooltip from "../../../../../componentsTopsa/infoTooptip/InfoTooltip";
import ReactTooltip from "react-tooltip";
import {Checkbox, Col, Row} from "react-bootstrap";
import StatusInTable from "./StatusInTable";
import GodzinaInTable from "./GodzinaInTable";
import {Link} from "react-router-dom";
import KonfiguracjaService from "../../../../administracja/konfiguracja/KonfiguracjaService";
import IleInTable from "./IleInTable";
import WyslijMailDoKlientaPopup from "../../../../komunikaty/powiadomienia/external_component/WyslijMailDoKlientaPopup";
import PopupZmienKursWBilecie from "./PopupZmienKursWBilecie";
import moment from "moment";

export default class JednorazoweTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultFilterKod: false,
            statusy: [
                {value: -1, label: 'do opłaty', ikona: 'fa fa-times-circle-o', kolor: '#333'},
                {value: 1, label: 'opłacony', ikona: 'fa fa-check-circle-o', kolor: '#333'},
                {value: 0, label: 'rezerwacja', ikona: 'fa fa-circle-o', kolor: '#333'},
                {value: 2, label: 'skasowany', ikona: 'fa fa-circle', kolor: '#333'},
                {value: -2, label: 'anulowano kl', ikona: 'fa fa-user-times', kolor: '#333'},
                {value: -3, label: 'anulowano op', ikona: 'fa fa-user-secret', kolor: '#333'},
                {value: -4, label: 'zwrócony', ikona: 'fa fa-refresh', kolor: '#333'},
                {value: -5, label: 'nieopłacony', ikona: 'fa fa-times', kolor: '#000'},
                {value: -6, label: 'płatność zwrócona', ikona: 'fa fa-refresh', kolor: '#111'},
            ],

            pokazPopupWyslijEmail: false,
            adresatEmail: "",
            czyPokazacKolumneNIP:false,

            showPopupZmienKurs:false,
            biletDoZmianyKursu:null
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.sprawdzCzyBiletJestNowy = this.sprawdzCzyBiletJestNowy.bind(this)
        this.renderKod = this.renderKod.bind(this)
        this.renderCena = this.renderCena.bind(this)
        this.renderIlosc = this.renderIlosc.bind(this)
        this.renderStatusy = this.renderStatusy.bind(this)
        this.renderDaneKomorki = this.renderDaneKomorki.bind(this)
        this.renderDaneKlienta = this.renderDaneKlienta.bind(this)
        this.renderDaneOdcinka = this.renderDaneOdcinka.bind(this)
        this.renderPlatnosc = this.renderPlatnosc.bind(this)
        this.renderGodzina = this.renderGodzina.bind(this)
    }

    componentDidMount() {
        if (Boolean(LSService.getObj('nowoDodanyBiletEBUS'))) {
            LSService.del('nowoDodanyBiletEBUS')
        }
        this.pobierzKoloryStatusowBiletow()
        this.wyszukajBiletyODanymIdKursu(this.props.szukaneIdKursu)

        this.renderPodsumowanieWidocznychRekordow();

    }

    componentWillReceiveProps(nextprops) {
        this.wyszukajBiletyODanymIdKursu(nextprops.szukaneIdKursu)
        this.renderPodsumowanieWidocznychRekordow();
    }

    wyszukajBiletyODanymIdKursu(kurs) {
        if (Boolean(kurs)) {
            this.refs.idKursu.applyFilter(kurs);
            this.props.wylaczIdKursuSzukanego();
        }
    }

    pobierzKoloryStatusowBiletow() {
        KonfiguracjaService.pobierzObiektySekcji('Status-kolor').then(function (response) {
            if (Boolean(response.data)) {

                let arr = response.data.filter(p => p.sekcja === 'Status-kolor')

                let statusyarr = this.state.statusy
                for (let i = 0; i < statusyarr.length; i++) {
                    let statuskolor = arr.find(p => p.pozycja == statusyarr[i].label)
                    if (Boolean(statuskolor)) {
                        statusyarr[i].kolor = statuskolor.wartosc
                    }
                }

                this.setState({statusy: statusyarr})

            }

        }.bind(this))
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń bilet'}/>
            </div>
        )
    }

    sprawdzCzyBiletJestNowy(idBi) {
        let czyNowyBilet = false;

        if (Boolean(LSService.getObj('nowoDodanyBiletEBUS'))) {
            if (Boolean(LSService.getObj('nowoDodanyBiletEBUS').find(obj => obj.idBi === idBi))) {
                czyNowyBilet = true
            }
        }

        return czyNowyBilet
    }

    renderKod(cell, row) {
        // gdy bilet jest połączonym
        if (Boolean(row.idBiPow)) {
            return (
                <div>
                    <div>
                        <span className={'label label-ebus-primary'}
                              style={this.sprawdzCzyBiletJestNowy(row.idBi) ? {background: 'dodgerblue'} : {}}>{row.idBi}</span>
                    </div>
                    <div style={{marginTop: '2px'}}>
                        <span className={'label label-ebus-secondary'} style={{cursor: 'pointer'}}
                              onClick={() => this.setState({defaultFilterKod: row.idBiPow.toString()})}
                              title={'Kliknij aby znaleść wszystkie bilety powiązane'}
                        >{row.idBiPow}</span>
                    </div>
                    <div style={{
                        fontSize: "10px",
                        color: "grey",
                        cursor: "pointer",
                        marginTop: "5px"
                    }} onClick={() => this.props.handleClickPokazWiecejInformacji(row.idBi)}>
                        <i className={"fa fa-search"}></i> Pokaz więcej info
                    </div>
                </div>
            )
        }// gdy jest podstawowym albo nie ma połączeń
        else {
            return (<div>
                <span className={'label label-ebus-primary'}
                      style={this.sprawdzCzyBiletJestNowy(row.idBi) ? {background: 'dodgerblue', cursor: 'pointer'} : {cursor: 'pointer'}}
                      onClick={() => this.setState({defaultFilterKod: row.idBi.toString()})}
                      title={'Kliknij aby znaleść wszystkie bilety powiązane'}
                >{row.idBi}</span>
                <div style={{
                    fontSize: "10px",
                    color: "grey",
                    cursor: "pointer",
                    marginTop: "5px"
                }} onClick={() => this.props.handleClickPokazWiecejInformacji(row.idBi)}>
                    <i className={"fa fa-search"}></i> Pokaz więcej info
                </div>
            </div>)
        }
    }

    renderCena(cell, row) {


        return <div>
            <div>
            <span
                style={(this.sprawdzCzyBiletJestNowy(row.idBi)) ? {color: 'dodgerblue',} : {color: 'inherit'}}>{acc.formatMoney(row.cena * row.ile)}</span>
            {// jesli dana cena byla promocyjna
                Boolean(row.idPro) ?
                    <span style={{marginLeft: '7px', color: '#132239', background: '#eee'}} className={'label label-ebus-secondary'}
                          title={'Cena promocyjna'}><i className={'fa fa-tag'}></i> {row.idPro}</span>
                    : ''
            }
            <div style={{fontSize: '12px', color: 'grey'}}>
                {acc.formatMoney(row.cena)}/szt
            </div>
            </div>
            {
                (row.nipParagon!== null && row.nipParagon!=='') &&
                <div style={{
                    fontSize: '12px', fontStyle:'italic', marginTop: '3px'
                }}>
                    NIP: {row.nipParagon}
                </div>
            }
        </div>
    }

    renderStatusy(cell, row) {

        let status = this.state.statusy.find(s => s.value == row.statPoz)
        let formaplat = ''
        if (row.formaPlatn == 'GK') formaplat = 'gotówka'
        if (row.formaPlatn == 'KK') formaplat = 'karta'
        if (row.formaPlatn == 'PR') formaplat = 'przelew'
        if (Boolean(status)) {
            return <div>
                <StatusInTable status={status}
                               statusy={this.state.statusy}
                               idBp={row.idBp}
                               handleSelectStatus={(e) => this.props.handleSelectStatus(e, row)}
                />
                {
                    row.statPoz === 2 || row.statPoz === -2 || row.statPoz === -4 ?
                        <div>
                            {
                                (row.statPoz === 2) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Skasował: {(row.skasowalKierowca) ? row.skasowalKierowca : "-"}</div>
                                    :
                                    ""
                            }
                            {
                                (row.statPoz === -2) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Anulowano: {(row.anulowanoData) ? row.anulowanoData.replace("T", " ").substr(0, 19) : "-"}</div>
                                    :
                                    ""
                            }
                            {
                                (row.statPoz === -4) ?
                                    <div style={{
                                        marginTop: '1px',
                                        marginLeft: '10px',
                                        color: 'grey',
                                        fontStyle: 'italic',
                                        fontSize: "12px"
                                    }}>Zwrot: {(row.zwrotProc) ? row.zwrotProc + "%" : "-"}, {(row.zwrotKwota) ? row.zwrotKwota + " zł" : "-"}</div>
                                    :
                                    ""
                            }
                        </div>
                        :
                        <div style={{marginTop: '1px', marginLeft: '10px', color: 'grey', fontStyle: 'italic', fontSize: "12px"}}>{formaplat}</div>

                }

            </div>
        }
    }

    renderZnizka(cell, row) {
        return <span className={'label label-ebus-default'} style={{color: '#fff', background: row.kolor}} title={row.nazZniz}>{cell}</span>
    }

    renderDaneKomorki(cell, row, idKu = null) {
        return <span style={Boolean(idKu) ? {
            fontWeight: 'bold',
            color: (this.sprawdzCzyBiletJestNowy(row.idBi)) ? 'dodgerblue' : 'inherit'
        } : {color: (this.sprawdzCzyBiletJestNowy(row.idBi)) ? 'dodgerblue' : 'inherit'}}>{cell}</span>
    }

    renderDaneOdcinka(cell, row) {
        return (
            <div>
                <div><span className={'label label-ebus-default'}>{row.nazTr}</span></div>
                <div style={{marginTop: '5px'}}>
                    <span style={(this.sprawdzCzyBiletJestNowy(row.idBi)) ? {color: 'dodgerblue'} : {color: 'inherit'}}>
                        <span>{row.nazMiOd}</span>
                        <i className={'fa fa-long-arrow-right'} style={{margin: '0 2px'}}></i>
                        <span>{row.nazMiDo}</span>
                    </span>
                </div>
            </div>
        )
    }

    renderDaneKlienta(cell, row) {

        if (row.idKl === 1) {     // gdy jest to jednorazowy klient
            return (
                <div title={'Klient Jednorazowy'}>
                    <div className={'pull-right'} title={'Miejsce sprzedaży'}>
                        <span style={{color: '#6cac3a', fontSize: '12px', fontStyle: 'italic'}}>{row.sprzedazMiejsce}</span>
                    </div>
                    <div>
                        <span className={'label label-ebus-default'}>K. Jednorazowy</span>
                        <div style={{marginTop: '3px'}}>
                            {row.klient}
                        </div>
                    </div>
                    <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '2px'}}>
                        {Boolean(row.klientTelefon) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                            className={'fa fa-phone'}></i> {row.klientTelefon}</span> : ''}
                        {
                            Boolean(row.klientEmail) ?
                                <span
                                    style={{display: 'inline-block', color: "dodgerblue", textDecoration: "underline", cursor: "pointer"}}
                                    onClick={() => this.setState({
                                        pokazPopupWyslijEmail: true, adresatEmail: row.klientEmail
                                    })}>
                                <i className={'fa fa-envelope'}></i> {row.klientEmail}</span>
                                : ''
                        }
                    </div>
                </div>
            )
        }
        else {
            // klient posiada konto

            // klient nie posiada uzupełnionego imienia i nazwiska (nazKl)
            if (!Boolean(row.nazKl)) {
                return (
                    <div title={'Bilet zakupiony na konto z nieuzupełnionymi danymi. Id konta: ' + row.idKl}>
                        <div className={'pull-right'} title={'Miejsce sprzedaży'}>
                            <span style={{color: '#6cac3a', fontSize: '12px', fontStyle: 'italic'}}>{row.sprzedazMiejsce}</span>
                        </div>
                        <div>
                            <i className={'fa fa-user'}
                               style={{marginRight: '5px', color: '#132239', textDecoration: 'none', fontSize: '12px'}}></i>
                            <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                                {row.klient}
                            </Link>
                        </div>
                        <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '5px'}}>
                            {Boolean(row.klientTelefon) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                className={'fa fa-phone'}></i> {row.klientTelefon}</span> : ''}
                            {Boolean(row.klientEmail) ?
                                <span style={{display: 'inline-block', color: "dodgerblue", textDecoration: "underline", cursor: "pointer"}}
                                      onClick={() => this.setState({
                                          pokazPopupWyslijEmail: true, adresatEmail: row.klientEmail
                                      })}><i
                                    className={'fa fa-envelope'}></i> {row.klientEmail}</span> : ''}
                        </div>
                    </div>
                )
            }
            else {
                return (   // dodane na klienta ktory posiada konto
                    <div>
                        <div data-tip='' data-for={'klient_data' + row.idKl + '-' + row.idBp} data-place="bottom" className='tooltip_here'>
                            <div style={{display: 'inline-block', lineHeight: '1.1em'}}>
                                {
                                    (row.nazKl == row.klient) ?
                                        <div>
                                            <div className={'pull-right'} title={'Miejsce sprzedaży'}>
                                                <span style={{color: '#6cac3a', fontSize: '12px', fontStyle: 'italic'}}>{row.sprzedazMiejsce}</span>
                                            </div>
                                            <div>
                                                <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                                                    {Boolean(row.nazKl) ? <span>{row.nazKl}</span> : ''}
                                                </Link>
                                            </div>
                                            <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '5px'}}>
                                                {Boolean(row.klientPesel) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                                    className={'fa fa-id-card-o'}></i> {row.klientPesel}</span> : ''}
                                                {Boolean(row.klientTelefon) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                                    className={'fa fa-phone'}></i> {row.klientTelefon}</span> : ''}
                                                {Boolean(row.klientEmail) ?
                                                    <span style={{
                                                        display: 'inline-block',
                                                        color: "dodgerblue",
                                                        textDecoration: "underline",
                                                        cursor: "pointer"
                                                    }}
                                                          onClick={() => this.setState({
                                                              pokazPopupWyslijEmail: true, adresatEmail: row.klientEmail
                                                          })}><i
                                                        className={'fa fa-envelope'}></i> {row.klientEmail}</span> : ''}
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <div className={'pull-right'} title={'Miejsce sprzedaży'}>
                                                <span style={{color: '#6cac3a', fontSize: '12px', fontStyle: 'italic'}}>{row.sprzedazMiejsce}</span>
                                            </div>
                                            <div style={{cursor: 'pointer', color: '#2780e3', textDecoration: 'underline'}}>
                                                <i className={'fa fa-user'} title={'Pasażer - Bilet zakupiony na inne konto'}
                                                   style={{marginRight: '5px', color: '#132239', textDecoration: 'none', fontSize: '12px'}}></i>
                                                <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                                                    {row.klient}
                                                </Link>
                                            </div>
                                            <div style={{color: 'grey', fontSize: '12px', lineHeight: '1.1em', marginTop: '5px'}}>
                                                {Boolean(row.klientPesel) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                                    className={'fa fa-id-card-o'}></i> {row.klientPesel}</span> : ''}
                                                {Boolean(row.klientTelefon) ? <span style={{display: 'inline-block', marginRight: '3px'}}><i
                                                    className={'fa fa-phone'}></i> {row.klientTelefon}</span> : ''}
                                                {Boolean(row.klientEmail) ?
                                                    <span style={{
                                                        display: 'inline-block',
                                                        color: "dodgerblue",
                                                        textDecoration: "underline",
                                                        cursor: "pointer"
                                                    }}
                                                          onClick={() => this.setState({
                                                              pokazPopupWyslijEmail: true, adresatEmail: row.klientEmail
                                                          })}><i
                                                        className={'fa fa-envelope'}></i> {row.klientEmail}</span> : ''}
                                            </div>
                                        </div>
                                }
                            </div>

                        </div>
                        <ReactTooltip id={'klient_data' + row.idKl + '-' + row.idBp}>
                            <Row>
                                <Col xs={12}>
                                    {
                                        (row.nazKl != row.klient) ?
                                            <div>
                                                Bilet zakupiony na konto:
                                            </div>
                                            :
                                            ''
                                    }

                                    <div>
                                        {
                                            Boolean(row.idKl) ?
                                                <div style={{lineHeight: '2em'}}><i className='fa fa-id-badge'
                                                                                    style={{marginRight: '5px'}}></i>Klient ID: {row.idKl}
                                                </div> : ''
                                        }
                                        {
                                            Boolean(row.nazKl) ?
                                                <div style={{lineHeight: '2em'}}><i className='fa fa-user'
                                                                                    style={{marginRight: '5px'}}></i> {row.nazKl}
                                                </div> : ''
                                        }{
                                        Boolean(row.klientPesel) ?
                                            <div style={{lineHeight: '2em'}}><i className='fa fa-id-card-o'
                                                                                style={{marginRight: '5px'}}></i>Pesel: {row.klientPesel}
                                            </div> : ''
                                    }
                                        {
                                            Boolean(row.klientTelefon) ?
                                                <div style={{lineHeight: '2em'}}><i className='fa fa-phone'
                                                                                    style={{marginRight: '5px'}}></i>Telefon: {row.klientTelefon}
                                                </div> : ''
                                        }
                                        {
                                            Boolean(row.klientEmail) ?
                                                <div style={{lineHeight: '2em'}}><i className='fa fa-envelope'
                                                                                    style={{marginRight: '5px'}}></i>Email: {row.klientEmail}
                                                </div> : ''
                                        }
                                    </div>
                                </Col>
                            </Row>

                        </ReactTooltip>
                    </div>
                )

            }
        }

    }

    renderPlatnosc(cell, row) {
        return (
            <div style={(this.sprawdzCzyBiletJestNowy(row.idBi)) ? {color: 'dodgerblue', fontSize: '12px'} : {color: 'inherit', fontSize: '12px'}}>
                {Boolean(row.dataWpisu) ?
                    <div title={"Data i godzina rejestracji transakcji biletu w systemie"}
                         style={{marginBottom: "5px", color: "grey", fontSize: "10px", fontStyle: "italic"}}><i
                        className={"fa fa-clock-o"}></i> {row.dataWpisu.replace("T", " ").substr(0, 19)}</div> : ""}
                <div>{Boolean(row.platnosciTransakcja) ? row.platnosciTransakcja : ''}</div>
                <div>{Boolean(row.platnoscTpay) ? row.platnoscTpay : ''}</div>
            </div>)
    }

    renderGodzina(cell, row) {
        if (Boolean(cell)) {

            let obj = {
                "data": row.waznyOd,
                "godz": null,
                "idPrDo": row.idPrDo,
                "idPrOd": row.idPrOd
            }
            return <div>
                <GodzinaInTable obj={obj} godz={row.godz.replace('.', ':')}
                                        handleChangeGodzina={(e) => this.props.handleChangeGodzina(e, row)}
                                        noedit={!(row.statPoz === 0 || row.statPoz === 1) || Boolean(row.idPro)}/>
                <div style={{color:'darkorange',fontSize:'9px', cursor:'pointer'}} onClick={()=>this.onClickZmienKurs(row)}>
                    <i className={'fa fa-pencil'}></i> <span>zmień kurs</span>
                </div>
                {row.sprzedazData !== null ? <div style={{color: 'grey', fontSize: 10, marginTop: 5}}>Sprzedano:<div><i class="fa fa-clock-o"/> {moment(row.sprzedazData).format('HH:mm')}</div></div> : null}
            </div>
        }
    }

    onClickZmienKurs = (obj) =>{
        this.setState({
            showPopupZmienKurs:true,
            biletDoZmianyKursu:obj
        })
    }

    renderIlosc(cell, row) {
        if (Boolean(cell)) {

            return <IleInTable
                ile={cell}
                idBp={row.idBp}
                canedit={row.sprzedazMiejsce === "KIEROWCA"}
                handleChangeIlosc={(idBp, ile) => this.props.handleChangeIlosc(idBp, ile)}
            />

        }
    }

    renderPodsumowanieWidocznychRekordow() {


        document.getElementById("tekstPodsumowania").style.display = "none";
        document.getElementById("ladowaniePodsumowania").style.display = "block";

        setTimeout(function () {

                if (this.props.data.length > 0) {
                    if (Boolean(this.refs.tableBiletyJednorazowe)) {

                        let arr = Array.from(this.refs.tableBiletyJednorazowe.props.data, item => {
                            let czyDodac = true;

                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.cena)) {

                                if (this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.comparator === "=") {
                                    if (parseFloat(this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.number) === parseFloat(item.cena)) {
                                    } else czyDodac = false
                                }

                                if (this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.comparator === "<") {
                                    if (parseFloat(item.cena) < parseFloat(this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.number)) {

                                    } else czyDodac = false
                                }

                                if (this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.comparator === ">") {
                                    if (parseFloat(item.cena) > parseFloat(this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.number)) {

                                    } else czyDodac = false
                                }

                                if (this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.comparator === "<=") {
                                    if (parseFloat(item.cena) <= parseFloat(this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.number)) {

                                    } else czyDodac = false
                                }

                                if (this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.comparator === ">=") {
                                    if (parseFloat(item.cena) >= parseFloat(this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.number)) {

                                    } else czyDodac = false
                                }

                                if (this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.comparator === "!=") {
                                    if (parseFloat(this.refs.tableBiletyJednorazowe.filter.currentFilter.cena.value.number) != parseFloat(item.cena)) {

                                    } else czyDodac = false
                                }

                            }
                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.godz)) {
                                // value: "8"
                                if ((item.godz.toString()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.godz.value) < 0) {
                                    czyDodac = false
                                }
                            }
                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.idKu)) {
                                if ((item.idKu.toString().toUpperCase()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.idKu.value.toUpperCase()) < 0) {
                                    czyDodac = false
                                }
                            }
                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.ile)) {
                                if ((item.ile.toString()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.ile.value) < 0) {
                                    czyDodac = false
                                }
                            }
                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.infoOdcinek)) {
                                if ((item.infoOdcinek.toString().toUpperCase()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.infoOdcinek.value.toUpperCase()) < 0) {
                                    czyDodac = false
                                }
                            }
                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.infoPlatnosci)) {
                                if ((item.infoPlatnosci.toString().toUpperCase()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.infoPlatnosci.value.toUpperCase()) < 0) {
                                    czyDodac = false
                                }
                            }
                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.klientInfo)) {
                                if ((item.klientInfo.toString().toUpperCase()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.klientInfo.value.toUpperCase()) < 0) {
                                    czyDodac = false
                                }
                            }
                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.kodInfo)) {
                                if ((item.kodInfo.toString()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.kodInfo.value) < 0) {
                                    czyDodac = false
                                }
                            }
                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.rodz)) {
                                // value: 2
                                if ((item.rodz.toString()).toUpperCase().indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.rodz.value.toUpperCase()) < 0) {
                                    czyDodac = false
                                }
                            }

                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.infoStatPoz)) {

                                if ((item.infoStatPoz.toString().toUpperCase()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.infoStatPoz.value.toUpperCase()) < 0) {
                                    czyDodac = false
                                }
                            }

                            if (Boolean(this.refs.tableBiletyJednorazowe.filter.currentFilter.waznyOd)) {
                                if ((item.waznyOd.toString()).indexOf(this.refs.tableBiletyJednorazowe.filter.currentFilter.waznyOd.value) < 0) {
                                    czyDodac = false
                                }
                            }

                            if (czyDodac) {
                                return item
                            }
                        })


                        let ileBiletow = 0;
                        let ileKasy = 0;

                        for (let i = 0; i < arr.length; i++) {
                            if (arr[i] !== undefined && arr[i] !== null) {

                                ileBiletow = ileBiletow + arr[i].ile
                                ileKasy = ileKasy + (arr[i].cena * arr[i].ile)
                            }
                        }


                        document.getElementById("tekstPodsumowania").style.display = "block";
                        document.getElementById("ladowaniePodsumowania").style.display = "none";
                        document.getElementById("calkowitaIloscBiletow").innerText = ileBiletow
                        document.getElementById("calkowitaWartoscBiletow").innerText = acc.formatMoney(ileKasy)
                    }
                }
            }

                .bind(
                    this
                ),
            3000
        )


    }

    render() {

        let statusy = {
            '-1': 'do opłaty',
            0: 'rezerwacja',
            1: 'opłacony',
            2: 'skasowany',
            '-2': 'anulowano kl',
            '-3': 'anulowano op',
            '-4': 'zwrócony',
            '-5': 'nieopłacony',
            '-6': 'płatność zwrócona',
        }

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
            onSortChange: () => this.renderPodsumowanieWidocznychRekordow(),
            // onSearchChange:()=>this.renderPodsumowanieWidocznychRekordow(),
            onFilterChange: () => this.renderPodsumowanieWidocznychRekordow(),
            //  onPageChange: () => this.renderPodsumowanieWidocznychRekordow(),
            //  onSizePerPageList: () => this.renderPodsumowanieWidocznychRekordow(),
        };
        return (
            <div>
                <div>
                    <div>
                        <div className={'pull-left'}>
                            <Checkbox
                                checked={this.state.czyPokazacKolumneNIP}
                                onChange={()=>this.setState({czyPokazacKolumneNIP:!this.state.czyPokazacKolumneNIP})}
                            >
                                Czy pokazać kolumnę NIP?
                            </Checkbox>
                        </div>
                        <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                            Ilość wyszukanych rekordów: {Boolean(this.props.data) ? this.props.data.length : 0}
                        </div>
                    </div>
                    <div>
                        <BootstrapTable data={this.props.data}
                                        options={options}
                                        pagination
                                        hover
                                        ref={'tableBiletyJednorazowe'}
                        >
                            <TableHeaderColumn dataField='kodInfo' isKey hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               filter={{
                                                   type: 'TextFilter',
                                                   delay: 500,
                                                   placeholder: 'Szukaj',
                                                   defaultValue: this.state.defaultFilterKod
                                               }}
                                               dataFormat={this.renderKod} dataSort
                            ><span>Kod {Boolean(this.state.defaultFilterKod) ?
                                <i className={'fa fa-times'} style={{color: 'firebrick', cursor: 'pointer'}} title={'Usuń filtrowanie'}
                                   onClick={() => {
                                       this.setState({defaultFilterKod: false})
                                   }}></i> : ''}</span></TableHeaderColumn>
                            <TableHeaderColumn dataField='waznyOd' dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderDaneKomorki}
                            >Ważny w</TableHeaderColumn>
                            <TableHeaderColumn dataField='godz'
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderGodzina}
                            >Godz.</TableHeaderColumn>
                            <TableHeaderColumn dataField='infoOdcinek'
                                               thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderDaneOdcinka}
                            ><InfoTooltip label={'Odcinek'}
                                          text={'Można szukać po: nazwa trasy, nazwa miejscowości od, nazwa miejscowości do'}/></TableHeaderColumn>
                            <TableHeaderColumn dataField='idKu' dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={(cell, row) => this.renderDaneKomorki(cell, row, 'idKu')}
                                               ref={"idKursu"}
                            >Kurs</TableHeaderColumn>
                            <TableHeaderColumn dataField='klientInfo'
                                               thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderDaneKlienta}
                            ><InfoTooltip label={'Dane pasażera i miejsce sprzedazy'}
                                          text={'Można szukać po: imie, nazwisko, telefon, email, miejsce sprzedaży [INTERNET, BIURO, MOBILE, KIEROWCA]'}/></TableHeaderColumn>
                            <TableHeaderColumn dataField='infoPlatnosci' dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderPlatnosc}
                            >Transakcja</TableHeaderColumn>
                            <TableHeaderColumn dataField='ile' dataSort
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderIlosc}
                            >Ilość</TableHeaderColumn>
                            <TableHeaderColumn dataField='cena' dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderCena}
                            >Wartość</TableHeaderColumn>


                            <TableHeaderColumn dataField='nipParagon' dataSort hidden={!this.state.czyPokazacKolumneNIP}
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                            >NIP</TableHeaderColumn>


                            <TableHeaderColumn dataField='rodz'
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderZnizka}
                            >Rodzaj</TableHeaderColumn>
                            <TableHeaderColumn dataField='infoStatPoz' dataSort
                                               thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                               dataFormat={this.renderStatusy}
                            >Status</TableHeaderColumn>
                        </BootstrapTable>
                    </div>

                    <div>
                        <div id={"ladowaniePodsumowania"}>
                            <div className={"pull-right"} style={{color: "grey", fontStyle: "italic"}}>
                                <i className={"fa fa-cog fa-spin"}></i>Trwa ładowanie podsumowania
                            </div>
                        </div>
                        <div id={"tekstPodsumowania"}>
                            <div className={"pull-right"}>
                                <p style={{color: "grey", fontStyle: "italic"}}>
                                    Podsumowanie:
                                </p>
                                <p>
                                    Calkowita ilość biletów: <span id={"calkowitaIloscBiletow"}>{this.state.ileBiletow}</span>
                                </p>
                                <p>
                                    Całkowita wartość: <span id={"calkowitaWartoscBiletow"}>{acc.formatMoney(this.state.ileKasy)}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    (this.state.pokazPopupWyslijEmail) ?
                        <WyslijMailDoKlientaPopup adresat={this.state.adresatEmail}
                                                  onClickZamknij={() => this.setState({pokazPopupWyslijEmail: false, adresatEmail: ""})}/>
                        : ""
                }
                {
                    this.state.showPopupZmienKurs &&
                        <PopupZmienKursWBilecie bilet={this.state.biletDoZmianyKursu} onClickAnuluj={()=>this.setState({showPopupZmienKurs:false, biletDoZmianyKursu:null})}
                                                handleClickZmienKurs={(idBi,idKu)=>{this.props.handleChangeKurs(idBi,idKu); this.setState({showPopupZmienKurs:false, biletDoZmianyKursu:null})}}
                        />
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/JednorazoweTable.js